export default __webpack_public_path__ + "static/media/soundcloud-bw.1234cc6d.svg";